var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('homeHero'),_c('aboutMe'),_c('skillSection'),_c('myProjects')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }